import { computed } from 'vue'
import { useAuthStore } from '~/stores/auth.js'

/**
 * Estado de la sesión de soporte y los desplazamientos que impone su barra fija.
 *
 * La barra mide 36px (`h-9`) y es de una sola línea, así que el offset es constante:
 * cualquier cosa anclada al borde superior de la ventana (navbars sticky, sidebar
 * fija) tiene que bajar esos 36px mientras esté activa.
 */
export function useImpersonation() {
  const authStore = useAuthStore()
  const impersonating = computed(() => !!authStore.impersonatedBy)

  return {
    impersonating,
    // Anclados a top-0
    topClass: computed(() => (impersonating.value ? 'top-9' : 'top-0')),
    // Anclados bajo una barra de 60px (sidebar del dashboard)
    belowBarClass: computed(() => (impersonating.value ? 'top-[96px]' : 'top-[60px]')),
    // Empuje del contenido para dejarle sitio
    offsetClass: computed(() => (impersonating.value ? 'pt-9' : '')),
  }
}
